import { send } from './client';

/** The four categories the API accepts; `StoreSupportMessageRequest::CATEGORIES`. */
export type SupportCategory = 'bug' | 'data' | 'access' | 'other';

export interface SupportMessageInput {
  category: SupportCategory;
  body: string;
}

export interface SupportMessageReceipt {
  uuid: string;
  category: SupportCategory;
  created_at: string;
}

/**
 * `POST /support-messages` (M-15d). No permission gates this — every
 * signed-in staff member may contact support.
 *
 * A 201 means the message was RECORDED, not that it was emailed: when the
 * mailbox address is unset the server stores the row and sends nothing,
 * deliberately (M-15d spec D-4).
 */
export const supportApi = {
  send: (input: SupportMessageInput) =>
    send<SupportMessageReceipt>('/support-messages', { method: 'POST', body: input }),
};
